
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'
import Tiptap from '~/components/ui/tiptap/index.vue'

export default Vue.extend({
  name: 'NewsItemPage',
  components: { Tiptap },
  mixins: [mixins.news]
})
